import { lensApi } from "@/services/lensApi";

export const blockageFeedback = {
	submit: async (
		blockageId: Dryp.BlockageId,
		eventStartMs: number,
		eventEndMs: number,
		classification: Dryp.BlockageFeedbackClassification,
	): Promise<void> => {
		await lensApi.post(`/blockage/${blockageId}/event-feedback`, {
			eventStartMs,
			eventEndMs,
			classification,
		});
	},

	remove: async (blockageId: Dryp.BlockageId, eventStartMs: number): Promise<void> => {
		await lensApi.delete(`/blockage/${blockageId}/event-feedback/${eventStartMs}`);
	},
};
